import { useQuery, useReactiveVar } from '@apollo/client';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import FormSelect from '../../../components/FormSelect/FormSelect';
import { FORM_SELECT_COMPONENT_TYPES, FORM_SELECT_TYPES } from '../../../components/FormSelect/types';
import { vars } from '../../../reactive';
import { increaseFormPage } from '../../../reactive/actions';
import { replaceVariables } from '../../../utils';
import { GetAllBreeds } from '../../../utils/queries';

const FormSelectBreed = () => {
  const type = FORM_SELECT_TYPES.BREED;
  const { title } = FORM_SELECT_COMPONENT_TYPES[type];
  const newPet = vars.newPet();
  const breeds = useReactiveVar(vars.breeds);
  const { data, loading } = useQuery(GetAllBreeds, {
    variables: {
      type: [newPet.type ?? 'DOG']
    }
  });
  const options = breeds?.filter(breed => breed.type === newPet.type);
  const { register, handleSubmit, reset } = useForm();

  const onSubmit = (data: Record<string, string>) => {
    vars.newPet({
      ...newPet,
      breed: options.filter(option => option.id === data.breed)[0].id
    });

    increaseFormPage();
  };

  useEffect(() => {
    if (data?.breedGet) {
      vars.breeds(data.breedGet);
    }
  }, [data]);

  return <FormSelect type={type} formOptions={{ register, handleSubmit, reset }} onSubmit={onSubmit} options={options} title={replaceVariables(title, { petName: newPet?.name })} loading={loading} />;
};

export default FormSelectBreed;
